import { ValidatorFn } from '~src/types';

export const isMoreThanZero: ValidatorFn = (str) => Number(str) > 0;

export const isNumber: ValidatorFn = (str) => {
  const num = Number(str);
  return !isNaN(num) && isFinite(num);
};

export const isFilled: ValidatorFn = (str) => !!str.trim().length;

export const isRuPhoneNumber: ValidatorFn = (str) =>
  /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/.test(
    str,
  );

export const isEmail: ValidatorFn = (str) => {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(str);
};
